import Instagram from './Instagram';

export default Instagram;
